<template>
    <li class="vue-approval-indicator">
        <a :href="destinationPath" class="indicator-handle">
            <span class="glyphicon glyphicon-ok menu-glyphicon"></span>

            <span class='badge progress-bar-info' v-if="queueLength">{{queueLength}}</span>
        </a>
   </li>
</template>

<script>
    export default {
        props: {
            destinationPath: {
                type: String,
                required: true
            },
            userId: {
                type: Number,
                required: true
            }
        },
        name: 'ApprovalIndicator',
        data () {
            return {
                queueLength: 0
            }
        },
        methods: {
            getMessageListener () {
                const self = this

                return function (event) {
                    if (Array.isArray(event.data)) {
                        let relevent = event.data.filter(datum => {
                            return (datum.module === 'Approval')
                        })

                        if (relevent.length) {
                            self.queueLength = relevent[0].queueLength
                        } else {
                            self.queueLength = 0
                        }
                    } else {
                        if (event.data.payload.module === 'Approval') {
                            self.queueLength = event.data.payload.queueLength
                        }
                    }
                }
            }
        },
        created () {
            if ('serviceWorker' in navigator) {
                // Handler for messages coming from the service worker
                navigator.serviceWorker.addEventListener('message', this.getMessageListener())
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.vue-approval-indicator .badge {
    position: absolute;
    top: 40%;
    right: 10%;
    font-size:0.7em;
}
</style>



// WEBPACK FOOTER //
// ApprovalIndicator.vue?952f403c